export const ISRESULT = 'ISRESULT';

//Dashboard

export const GET_DATA_DASHBOARD = 'GET_DATA_DASHBOARD';
export const GET_DATA_DASHBOARD_SUCCEEDED = 'GET_DATA_DASHBOARD_SUCCEEDED';
export const GET_DATA_DASHBOARD2 = 'GET_DATA_DASHBOARD2';
export const GET_DATA_DASHBOARD2_SUCCEEDED = 'GET_DATA_DASHBOARD2_SUCCEEDED';
export const GET_DATA_DASHBOARD3 = 'GET_DATA_DASHBOARD3';
export const GET_DATA_DASHBOARD3_SUCCEEDED = 'GET_DATA_DASHBOARD3_SUCCEEDED';
export const GET_DATA_DASHBOARD4 = 'GET_DATA_DASHBOARD4';
export const GET_DATA_DASHBOARD4_SUCCEEDED = 'GET_DATA_DASHBOARD4_SUCCEEDED';
export const REQUERT_DATA_DASHBOARD_FAILED = 'GET_DATA_DASHBOARD_FAILED';
export const GET_DATA_DASHBOARD5 = 'GET_DATA_DASHBOARD5';
export const GET_DATA_DASHBOARD5_SUCCEEDED = 'GET_DATA_DASHBOARD5_SUCCEEDED';
export const GET_DATA_DASHBOARD6 = 'GET_DATA_DASHBOARD6';
export const GET_DATA_DASHBOARD6_SUCCEEDED = 'GET_DATA_DASHBOARD6_SUCCEEDED';
// Get danh sách chờ bạn xác nhận
//export const REQUERT_DATA_DASHBOARD_FAILED = 'GET_DATA_DASHBOARD_FAILED';
export const GET_DATA_PLAN_DASHBOARD = 'GET_DATA_PLAN_DASHBOARD';
export const GET_DATA_PLAN_DASHBOARD_SUCCEEDED = 'GET_DATA_PLAN_DASHBOARD_SUCCEEDED';
//Get danh sách kế hoạch tuần kế tiếp( KH Deploy)
export const GET_DATA_PLAN_NEXTWEEK_DASHBOARD = 'GET_DATA_PLAN_NEXTWEEK_DASHBOARD';
export const GET_DATA_PLAN_NEXTWEEK_DASHBOARD_SUCCEEDED = 'GET_DATA_PLAN_NEXTWEEK_DASHBOARD_SUCCEEDED';
//Get danh sách kế hoạch gia hạn
export const GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD = 'GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD';
export const GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD_SUCCEEDED = 'GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD_SUCCEEDED';
export const REQUERT_DATA_PLAN_DASHBOARD_FAILED = 'REQUERT_DATA_PLAN_DASHBOARD_FAILED';